export default __webpack_public_path__ + "static/kiln-7-fdb28f2bce6ebd2d756647f38b7f240d.jpg";